import { V, V2d } from "../../../core/Vector";
import { BaseVectorFilter } from "../BaseVectorFilter";
import { SegmentFilterContext, VectorSegment } from "../VectorSprite";

/**
 * Move segments by velocity vectors (for particle effects)
 * Accumulates movement over time for proper particle motion
 */
export class MovementFilter extends BaseVectorFilter {
  private accumulatedOffsets: V2d[] = [];

  constructor(private velocities: V2d[]) {
    super();
    // Initialize accumulated offsets to zero
    this.accumulatedOffsets = velocities.map(() => V(0, 0));
  }

  setVelocities(velocities: V2d[]): void {
    this.velocities = velocities;
    // Reset accumulated offsets when velocities change
    this.accumulatedOffsets = velocities.map(() => V(0, 0));
  }

  onTick(dt: number): void {
    // Accumulate movement over time
    this.accumulatedOffsets = this.accumulatedOffsets.map((offset, i) => {
      const velocity = this.velocities[i] || V(0, 0);
      const movement = V(velocity).mul(dt);
      return V(offset).add(movement);
    });
  }

  apply(
    segments: VectorSegment[],
    _context: SegmentFilterContext,
  ): VectorSegment[] {
    return segments.map((segment, i) => {
      const totalOffset = this.accumulatedOffsets[i] || V(0, 0);

      return {
        ...segment,
        start: V(segment.start).add(totalOffset),
        end: V(segment.end).add(totalOffset),
      };
    });
  }
}
